'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorsWhitelistedUrl = void 0;
class CorsWhitelistedUrl {
    constructor({ id, url }) {
        this.id = id;
        this.url = url;
    }
    getUrl(defaultValue) {
        if (this.url != undefined && this.url != null) {
            return this.url;
        }
        if (defaultValue != undefined && defaultValue != null) {
            return defaultValue;
        }
        return null;
    }
}
exports.CorsWhitelistedUrl = CorsWhitelistedUrl;
//# sourceMappingURL=cors-whitelisted-url.model.js.map